var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        id: "input-group-1",
        label: `${_vm.label || "Foto: "} ${
          _vm.state.file && !_vm.state.url ? _vm.state.file.name : ""
        }`,
        "label-for": "input-1"
      }
    },
    [
      _vm.state.url && _vm.isDoc
        ? _c(
            "b-button",
            {
              attrs: {
                type: "button",
                variant: "outline-dark",
                target: "_blank",
                href: _vm.state.url
              }
            },
            [_c("b-icon-eye"), _vm._v(" Ver Arquivo\n  ")],
            1
          )
        : _vm.state.url && !_vm.isDoc
        ? _c("b-avatar", { attrs: { src: _vm.state.url, size: "lg" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.state.url
        ? _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: { type: "button" },
              on: { click: () => _vm.remove() }
            },
            [_c("b-icon-trash"), _vm._v(" Remover\n  ")],
            1
          )
        : _c(
            "div",
            { staticClass: "example-btn" },
            [
              _c(
                "file-upload",
                {
                  ref: "upload",
                  staticClass: "btn btn-secondary",
                  attrs: {
                    "post-action": "/api/upload/",
                    extensions: _vm.extensions || "gif,jpg,jpeg,png,webp",
                    accept:
                      _vm.accept ||
                      "image/png, image/gif, image/jpeg, image/webp",
                    multiple: false,
                    size: 1024 * 1024 * 10
                  },
                  on: {
                    "input-filter": _vm.inputFilter,
                    "input-file": _vm.inputFile
                  },
                  model: {
                    value: _vm.state.files,
                    callback: function($$v) {
                      _vm.$set(_vm.state, "files", $$v)
                    },
                    expression: "state.files"
                  }
                },
                [
                  _c("b-icon-plus"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.state.file ? "Alterar" : "Adicionar"))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              this.state.file
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.$refs.upload.active = true
                        }
                      }
                    },
                    [
                      _vm.viewData.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _c(
                            "span",
                            [_c("b-icon-upload"), _vm._v(" Upload\n      ")],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.state.file
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button" },
                      on: { click: () => this.remove() }
                    },
                    [_c("b-icon-trash"), _vm._v(" Remover\n    ")],
                    1
                  )
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }